<template>
  <v-modal
    v-if="true"
    size="sm"
    @hide-modal="$emit('hide-modal')"
  >
    <template v-slot:title>
      <h3>
        {{ $t('phrase.reset_password') }}
      </h3>
    </template>
    <template v-slot:body>
      <form method="post" @submit.prevent="submit">
        <div class="mb-3">
          <v-text-input
            id="reset-password-old-password"
            label="phrase.old_password"
            type="password"
            v-model="data.old_password"
            :errors="errors.old_password"
          />
        </div>
        <div class="mb-3">
          <v-text-input
            id="reset-password-new-password-1"
            label="phrase.new_password"
            type="password"
            v-model="data.new_password1"
            :errors="errors.new_password1"
          />
        </div>
        <div class="mb-3">
          <v-text-input
            id="reset-password-new-password-2"
            label="phrase.new_password_repeat"
            type="password"
            v-model="data.new_password2"
            :errors="errors.new_password2"
          />
        </div>

        <v-form-errors
          :errors="errors.non_field_errors"
        />

        <div class="d-flex justify-content-end">
          <v-button
            id="reset-password-submit"
            text="word.save"
            type="submit"
            :loader="loader"
          />
        </div>
      </form>
    </template>
  </v-modal>
</template>

<script>
import Button from '@/common/components/Button.vue';
import Modal from '@/common/components/Modal.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import FormErrors from '@/common/components/FormErrors.vue';
import { notify } from '@/common/utils/notify';
import { GenericFormMixin } from '@/common/utils/mixins';

export default {
  name: 'ResetPasswordModal',
  mixins: [
    GenericFormMixin,
  ],
  components: {
    'v-button': Button,
    'v-form-errors': FormErrors,
    'v-modal': Modal,
    'v-text-input': TextInput,
  },
  data() {
    return {
      apiPath: 'users/password/',
      apiMethod: 'patch',
      data: {
        old_password: '',
        new_password1: '',
        new_password2: '',
      },
    };
  },
  methods: {
    postProcess() {
      notify('phrase.reset_password', 'sentence.password_changed');
      this.$emit('hide-modal');
    },
  },
};
</script>
